import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonServiceCrumbs } from 'system/constants/common-service-crumbs';
import OperatorEdit from 'system/components/operators/edit';
import { useParams, useNavigate, generatePath } from 'react-router';

const OperatorEditPageServiceDetail = (): React.ReactElement => {
  const params = useParams();
  const navigate = useNavigate();

  const onSuccess = useCallback(() => {
    navigate(generatePath('/sistema/servizi/dettaglio/:id', params));
  }, [navigate]);

  const onCancel = useCallback(() => {
    navigate(generatePath('/sistema/servizi/dettaglio/:id', params));
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonServiceCrumbs,
          { name: 'Dettaglio Servizio', path: '/sistema/servizi/dettaglio/:id' },
          { name: 'Modifica Operatore' },
        ]}
      />
      <OperatorEdit onSuccess={onSuccess} onCancel={onCancel} id={params.idOperatore} />
    </Fragment>
  );
};

OperatorEditPageServiceDetail.displayName = 'Operator Edit page component from service';

export default OperatorEditPageServiceDetail;
